



import Page from '../PostSales/sale/PostSaleList.vue'
export default {
  name: 'postsalelistRD',
  components: { Page },
}
